module.exports = __webpack_public_path__ + "static/media/pic1.8b4c2489.jpg";